// extracted by mini-css-extract-plugin
module.exports = {"remove":"Icon--remove--1PRQf","info":"Icon--info--1iiBw"};